// Shamble — ported verbatim from GolfGamesScorecard's calcShamble
// (utils/scoring.ts). Best team score per hole; lowest team total wins.
export function calcShamble(teams) {
  return (teams || [])
    .map((team) => {
      const teamScore = Array.from({ length: 18 }, (_, hole) => {
        const scores = team.map((p) => p.scores[hole]).filter((s) => s !== null && s !== undefined)
        return scores.length ? Math.min(...scores) : null
      })
      return { team, teamScore, total: teamScore.reduce((s, v) => s + (v ?? 0), 0) }
    })
    .sort((a, b) => a.total - b.total)
}
